"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Button = _interopRequireDefault(require("./../../../Button"));

var _polished = require("polished");

var _Close = _interopRequireDefault(require("../../../icons/utils/Close"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var buttonCss = (0, _styledComponents.css)(["position:absolute;top:", ";right:", ";padding:", ";min-width:0;color:", ";", " svg{height:", ";width:", ";path{fill:", ";}}&:hover{box-shadow:none;}"], (0, _polished.rem)('22px'), function (props) {
  return props.theme.spacing.medium;
}, (0, _polished.rem)('12px'), function (_ref) {
  var theme = _ref.theme;
  return theme.colors.system.cta.base;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.media.medium((0, _styledComponents.css)(["top:", ";"], (0, _polished.rem)('19px')));
}, (0, _polished.rem)('10px'), (0, _polished.rem)('10px'), function (_ref3) {
  var theme = _ref3.theme;
  return theme.colors.system.cta.base;
});

var _StyledButton = (0, _styledComponents.default)(_Button.default).withConfig({
  displayName: "ModalClose___StyledButton",
  componentId: "gxewny-0"
})(["", ""], buttonCss);

var ModalClose = function ModalClose(_ref4) {
  var description = _ref4.description,
      onClose = _ref4.onClose;
  return /*#__PURE__*/_react.default.createElement(_StyledButton, {
    className: "ui-modal-close",
    variant: "tertiary",
    "aria-label": "Close ".concat(description),
    onClick: onClose
  }, /*#__PURE__*/_react.default.createElement(_Close.default, null));
};

ModalClose.propTypes = {
  /** _Optional_ string to describe general modal functionality. It is recommended that the end user provide a `description` since it will be used in ARIA content. */
  description: _propTypes.default.string.isRequired,

  /** _Required_ event handler called when the modal is closed via close "X" icon in upper right corner.  */
  onClose: _propTypes.default.func.isRequired
};
var _default = ModalClose;
exports.default = _default;
//# sourceMappingURL=ModalClose.js.map